module.exports = __webpack_public_path__ + "static/media/dashboardDark.94534c07.svg";